import { useCallback } from "react";
import useRealtimeChannel from "@/hooks/useRealtimeChannel";

export default function useCheckoutRealtime({
  checkoutKey,
  enabled = true,
  onConfirmed,
  onPending,
  onExpired,
  onUpdate,
}) {
  const handleMessage = useCallback(
    (payload) => {
      onUpdate?.(payload);

      const checkoutStatus = payload?.meta?.status || payload?.meta?.payment_status;
      if (payload?.event === "payment_confirmed" || checkoutStatus === "paid" || checkoutStatus === "confirmed") {
        onConfirmed?.(payload);
        return;
      }

      if (payload?.event === "payment_pending" || checkoutStatus === "pending" || checkoutStatus === "awaiting_payment") {
        onPending?.(payload);
        return;
      }

      if (
        payload?.event === "payment_expired" ||
        payload?.event === "payment_cancelled" ||
        checkoutStatus === "expired" ||
        checkoutStatus === "cancelled"
      ) {
        onExpired?.(payload);
      }
    },
    [onConfirmed, onExpired, onPending, onUpdate]
  );

  useRealtimeChannel({
    enabled: enabled && Boolean(checkoutKey),
    path: checkoutKey ? `/checkout/${checkoutKey}` : null,
    eventType: "checkout_update",
    onMessage: handleMessage,
  });
}
